<template>
    <div class="home">
        <!-- Start:Header -->
        <Header />
        <!-- End:Header -->

        <!-- Start:Slider -->
        <Slider />
        <!-- End:Slider -->

        <!-- Start:Main Content -->
        <div class="card card-body blur shadow-blur mx-3 mx-md-4 mt-4 mb-4">

            <section class="my-5 py-2">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-3 ms-auto me-auto p-lg-2 mt-lg-0 mt-4 mb-3 align-items-center">

                            <div v-if="kepalas.length > 0">
                                <div v-for="kepala in kepalas" :key="kepala.id" class="card" style="width: 100%; border:0">
                                    <img :src="web.url_admin + 'storage/datastatis/' + kepala.file" class="w-100"
                                        style="height: auto">
                                </div>
                            </div>

                            <div v-else>
                                <div class="row">
                                    <div v-for="loader in kepalas_loader" :key="loader">
                                        <ContentLoader height="400px" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 ms-auto">
                            <div class="row justify-content-start mb-5 mt-4">

                                <div v-if="kepalas.length > 0">
                                    <div v-for="kepala in kepalas" :key="kepala.id">
                                        <h3 style="font-weight:bold;" v-html="kepala.konten.toUpperCase()"></h3>
                                        <h4>{{ kepala.judul.toUpperCase() }}</h4>
                                        <hr />
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="row">
                                        <div v-for="loader in kepalas_loader" :key="loader">
                                            <ContentLoader width="50%" height="20px" /><br />
                                            <ContentLoader width="80%" height="20px" /><br /><br />
                                        </div>
                                    </div>
                                </div>

                                <div v-if="sambutans.length > 0">
                                    <div v-for="sambutan in sambutans" :key="sambutan.id"
                                        class="text-dark text-decoration-none">
                                        <div v-if="sambutan.konten.includes('http')">
                                            <p style="font-size: 20px; text-align: justify;">
                                                Assalamu'alaikum Wr. Wb.<br />
                                                Selamat Datang di Website Kelurahan Gunung Batu Kota Bogor.
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p style="font-size: 20px; text-align: justify;"
                                                v-html="sambutan.konten.substring(0, 375) + '...'"></p>
                                        </div>
                                    </div>

                                    <div>
                                        <router-link :to="{ name: 'Sambutan' }">
                                            <button type="button" class="btn btn-outline-primary btn-md">Lihat
                                                Selengkapnya</button>
                                        </router-link>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="row">
                                        <div v-for="loader in sambutans_loader" :key="loader">
                                            <ListLoader />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="py-3">
                <div class="container mt-3 mb-5">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="row">

                                <!-- berita section -->
                                <div class="col-md-12 mb-3">
                                    <h5><i class="fas fa-book-open"></i> Berita Terbaru</h5>
                                </div>

                                <nav class="col-md-12 mb-2">
                                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button class="nav-link active" id="nav-pd-tab" data-bs-toggle="tab"
                                            data-bs-target="#beritapd" type="button" role="tab" aria-controls="beritapd"
                                            aria-selected="true">Berita {{ web.nama_web }}</button>
                                        <button class="nav-link" id="nav-kota-tab" data-bs-toggle="tab"
                                            data-bs-target="#beritakota" type="button" role="tab" aria-controls="beritakota"
                                            aria-selected="false">Berita Kota Bogor</button>
                                    </div>
                                </nav>

                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active" id="beritapd" role="tabpanel"
                                        aria-labelledby="nav-pd-tab">
                                        <!-- berita section -->
                                        <div v-if="beritas.length > 0" class="row">
                                            <div class="col-md-4 mb-4" v-for="berita in beritas" :key="berita.id">
                                                <div class="card h-100 shadow-sm border-0 rounded-lg"
                                                    style="max-height:800px">
                                                    <div class="card-img">
                                                        <div v-if="berita.foto.includes('pdf')">
                                                            <img :src="web.url_admin + 'storage/berita/no-image.jpg'"
                                                                class="w-100"
                                                                style="height: 200px;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                                        </div>
                                                        <div v-else>
                                                            <img :src="berita.foto" class="w-100"
                                                                style="height: 200px;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                                        </div>
                                                    </div>
                                                    <div class="card-body">
                                                        <router-link
                                                            :to="{ name: 'detail_berita', params: { slug: berita.slug, kategori: berita.kategori_nama.toLowerCase() } }"
                                                            class="text-dark text-decoration-none">
                                                            <h6><b>{{ berita.judul }}</b></h6>
                                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{
                                                                dateTime(berita.tgl) }}
                                                            <div
                                                                v-if="berita.isi.includes('jpg') || berita.isi.includes('jpeg') || berita.isi.includes('png')">
                                                                <br />Klik link di bawah untuk melihat detail
                                                                berita<br /><br />
                                                            </div>
                                                            <div v-else>
                                                                <div class="mt-3" v-html="berita.isi.substring(0, 93) + '...'">
                                                                </div>
                                                            </div>
                                                            <p style="color: #0044D0; font-weight: bold">Baca Selengkapnya
                                                            </p>
                                                        </router-link>
                                                    </div>
                                                    <!-- <div class="card-footer bg-white">
                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{ dateTime(berita.tgl) }}
                                        </div> -->
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else>
                                            <div class="row">
                                                <div class="col-md-4 mb-3" v-for="loader in beritas_loader" :key="loader">
                                                    <div class="card border-0 shadow-sm rounded-lg">
                                                        <div class="card-body">
                                                            <FacebookLoader />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- end berita section -->
                                    </div>


                                    <div class="tab-pane fade" id="beritakota" role="tabpanel"
                                        aria-labelledby="nav-kota-tab">
                                        <!-- berita kota section -->

                                        <div class="row">
                                            <div class="col-md-4 mb-4" v-for="beritabogor in beritakota['Berita Bogor']"
                                                :key="beritabogor.postid">
                                                <div class="card h-100 shadow-sm border-0 rounded-lg"
                                                    style="max-height:800px">
                                                    <div class="card-img">
                                                        <img :src="beritabogor.gambar" class="w-100"
                                                            style="height: 200px;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                                    </div>
                                                    <div class="card-body">
                                                        <a :href="'http://kotabogor.go.id/index.php/show_post/detail/' + beritabogor.postid + '/' + beritabogor.slugpost"
                                                        class="text-dark text-decoration-none" target="_BLANK">
                                                            <h6><b>{{ beritabogor.judul }}</b></h6>
                                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{
                                                                beritabogor.tanggal }}
                                                            <div class="mt-3"
                                                                v-html="beritabogor.konten.substring(0, 93) + '...'"></div>
                                                            <p style="color: #0044D0; font-weight: bold">Baca Selengkapnya
                                                            </p>
                                                        </a>
                                                    </div>
                                                    <!-- <div class="card-footer bg-white">
                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{ dateTime(berita.tgl) }}
                                        </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- berita kota section -->
                                <!-- <div class="col-md-12 mb-3 mt-4">
                            <h5><i class="fas fa-book-open"></i> Berita Kota Bogor</h5>
                        </div> -->

                                <!-- <div class="row">
                            <div class="col-md-4 mb-4" v-for="beritabogor in beritakota['Berita Bogor']" :key="beritabogor.postid">
                                <div class="card h-100 shadow-sm border-0 rounded-lg" style="max-height:800px">
                                    <div class="card-img">
                                        <img :src="beritabogor.gambar" class="w-100"
                                            style="height: 200px;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                    </div>
                                    <div class="card-body">
                                        <a href="http://kotabogor.go.id/index.php/show_post/detail/{{ beritabogor.postid }}" class="text-dark text-decoration-none" target="_BLANK">
                                            <h6><b>{{ beritabogor.judul }}</b></h6>
                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{ beritabogor.tanggal }}
                                            <div class="mt-3" v-html="beritabogor.konten.substring(0,165)+'...'" style="text-align: justify;"></div>
                                            <p style="color: rgb(214, 126, 57); font-weight: bold">Baca Selengkapnya</p>
                                        </a>
                                    </div>
                                    <div class="card-footer bg-white">
                                        <i class="fa fa-calendar" aria-hidden="true"></i> {{ dateTime(berita.tgl) }}
                                    </div>
                                </div>
                            </div>
                        </div> -->
                                <!-- end berita kota section -->

                                <!-- foto section -->
                                <div class="col-md-12 mb-3 mt-4">
                                    <h5><i class="fas fa-images"></i> Foto Terbaru</h5>
                                </div>

                                <div v-if="photos.length > 0" class="row">
                                    <div class="col-xl-4 mb-3" v-for="photo in photos" :key="photo.id">
                                        <div class="card h-100 shadow-sm border-0 rounded-xl">
                                            <div class="card-img">
                                                <img :src="photo.foto" class="w-100"
                                                    style="height: 200px;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                            </div>
                                            <div class="card-body">
                                                {{ photo.keterangan }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="row">
                                        <div class="col-xl-4 mb-3" v-for="loader in photos_loader" :key="loader">
                                            <div class="card border-0 shadow-sm rounded-lg">
                                                <div class="card-body p-2">
                                                    <ContentLoader />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- end foto section -->

                                <!-- video section -->
                                <div class="col-md-12 mb-3 mt-4">
                                    <h5><i class="fas fa-video"></i> Video Terbaru</h5>
                                </div>

                                <div v-if="videos.length > 0" class="row">
                                    <div class="col-md-6 mb-4" v-for="video in videos" :key="video.id">
                                        <div class="card h-100 shadow-sm border-0 rounded-lg">
                                            <div class="card-img">
                                                <iframe
                                                    style="width:100%;height:220px;border-top-left-radius:.3rem;border-top-right-radius:.3rem"
                                                    :src="'https://www.youtube.com/embed/' + video.embed" frameborder="0"
                                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                    allowfullscreen></iframe>
                                            </div>
                                            <div class="card-body">
                                                {{ video.title }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="row">
                                        <div class="col-md-6 mb-4" v-for="loader in videos_loader" :key="loader">
                                            <div class="card border-0 shadow-sm rounded-lg">
                                                <div class="card-body p-2">
                                                    <ContentLoader />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- end video section -->

                            </div>
                        </div>
                        <div class="col-md-4">

                            <!-- kalendar section -->
                            <div class="title mb-4">
                                <h5><i class="far fa-calendar-alt" aria-hidden="true"></i> Kalendar</h5>
                            </div>

                            <div>
                                <div class="card pt-3 shadow-sm border-0 mb-4">
                                    <div class="card-body">
                                        <div>
                                            <h6>{{ dateNow() }}</h6>
                                        </div>
                                        <hr>
                                        <div class="mt-2">
                                            <h6>{{ dateHijr() }} H</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end kalendar section -->

                            <!-- agenda section -->
                            <div class="title mb-4">
                                <h5><i class="far fa-calendar-check" aria-hidden="true"></i> Agenda</h5>
                            </div>

                            <div v-if="agendas.length > 0">
                                <div class="card pt-3 shadow-sm border-0 overflow-auto" style="max-height:358px">
                                    <!-- <router-link :to="{name: 'detail_event', params:{slug: agenda.slug}}" v-for="agenda in agendas"
                                :key="agenda.id" class="text-decoration-none text-dark"> -->
                                    <div v-for="agenda in agendas" :key="agenda.id">
                                        <div class="card-body">
                                            <h6 style="font-weight:bold;">{{ agenda.nama_agenda }}</h6>
                                            <div>
                                                <i class="fa fa-map-marker" aria-hidden="true"></i> {{ agenda.lokasi_agenda
                                                }}
                                            </div>
                                            <div class="mt-2">
                                                <i class="fa fa-calendar" aria-hidden="true"></i> {{
                                                    dateTime(agenda.tgl_agenda) }} |
                                                <i class="fa fa-clock" aria-hidden="true"></i> {{ agenda.waktu }}
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                    <!-- </router-link> -->
                                </div>
                            </div>

                            <div v-else>
                                <div class="row">
                                    <div v-for="loader in agendas_loader" :key="loader">
                                        <div class="card border-0 shadow-sm rounded-lg mb-3">
                                            <div class="card-body pt-4">
                                                <FacebookLoader />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- end agenda section -->

                            <!-- Tags section -->
                            <!-- <div class="title mb-4 mt-5">
                        <h5><i class="fa fa-tags" aria-hidden="true"></i> Tags</h5>
                    </div>

                    <div v-if="tags.length > 0">
                        <router-link :to="{name: 'detail_tag', params: { slug: tag.slug }}" v-for="tag in tags" :key="tag.id" class="btn btn-sm btn-outline-secondary mb-2 me-2">{{ tag.name.toUpperCase() }}</router-link>
                    </div>
                    <div v-else class="text-center">
                        <ListLoader/>
                    </div> -->
                            <!-- End tags section -->

                            <!-- Embed instagram section -->
                            <div class="col-md-12 mb-3 mt-4">
                                <h5><i class="fab fa-instagram"></i> Instagram {{ web.nama_web }}</h5>
                            </div>

                            <div class="row">
                                <div class="col-md-12 mb-2">
                                    <div class="card h-100 shadow-sm border-0">
                                        <div class="card-img">
                                            <!-- <div class="elfsight-app-64d5f4d3-05f8-4e74-b9ab-5f195bbb7ed5" data-elfsight-app-lazy></div> -->
                                            <iframe class="instagram-media instagram-media-rendered" id="instagram-embed-0" src="https://www.instagram.com/setwankotabogor/embed/?cr=1&amp;v=12&amp;wp=696&amp;rd=https%3A%2F%2Fsetwankotabogor.kotabogor.go.id&amp;rp=%2F#%7B%22ci%22%3A0%2C%22os%22%3A927.3999999910593%2C%22ls%22%3A396.8999999910593%2C%22le%22%3A920.2999999970198%7D" allowtransparency="true" allowfullscreen="true" frameborder="0" height="426" data-instgrm-payload-id="instagram-media-payload-0" scrolling="no" style="background-color: white; border-radius: 3px; border: 1px solid rgb(219, 219, 219); box-shadow: none; display: block; margin: 0px 0px 12px; min-width: 326px; padding: 0px;"></iframe>
                                            <!-- <a target="_blank" href="https://www.instagram.com/bkadkotabogor/" class="w-100"> -->
                                            <!-- <iframe src="https://snapwidget.com/embed/1011254" class="snapwidget-widget" allowtransparency="true" frameborder="0" scrolling="no" style="border:none; overflow:hidden;  width:100%; "></iframe> -->
                                            <!-- <iframe src="https://snapwidget.com/embed/1011258" 
                                        class="snapwidget-widget"
                                        allowtransparency="true" 
                                        frameborder="0" 
                                        scrolling="no" 
                                        style="border:none; overflow:hidden; width:100%; ">
                                        </iframe>
                                    </a> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Embed instagram section -->

                            <!-- Banner pengumuman section -->
                            <div class="col-md-12 mb-3 mt-4">
                                <h5><i class="fas fa-image"></i> Banner</h5>
                            </div>

                            <div v-if="pengumumans.length > 0" class="row">
                                <div class="col-md-12 mb-2" v-for="pengumuman in pengumumans" :key="pengumuman.id">
                                    <div class="card h-100 shadow-sm border-0">
                                        <div class="card-img">
                                            <img :src="pengumuman.gambar" class="w-100"
                                                style="height: auto;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div class="row">
                                    <div class="col-md-6 mb-3" v-for="loader in pengumumans_loader" :key="loader">
                                        <div class="card border-0 shadow-sm rounded-lg">
                                            <div class="card-body p-2">
                                                <ContentLoader />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end banner pengumuman section -->

                            <!-- Banner link section -->
                            <div v-if="links.length > 0" class="row">
                                <div class="col-md-12 mb-2">
                                    <div class="card h-100 shadow-sm border-0">
                                        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                                            <!-- <div v-if="links.length > 0"> -->
                                            <div class="carousel-inner">
                                                <div>
                                                    <div class="carousel-item" v-for="(link, id) in links"
                                                        :class="{ active: id == 0 }" :key='link.id'>
                                                        <a :href="link.link" target="_blank">
                                                            <img :src="link.gambar" class="w-100"
                                                                style="height:auto;object-fit:cover; margin-top: 0.5rem;">
                                                        </a>
                                                    </div>
                                                </div>
                                                <!-- <div v-else class="mt-2">
                                            <div class="card border-0 shadow-sm rounded-lg mb-3" v-for="loader in links_loader" :key="loader">
                                                <div class="card-body pt-4">
                                                    <ContentLoader />
                                                </div>
                                            </div>
                                        </div> -->
                                            </div>
                                        </div>
                                        <!-- <div class="card-img">
                                    <img :src="pengumuman.gambar" class="w-100"
                                        style="height: auto;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                </div> -->
                                        <a class="carousel-control-prev" href="#carouselExampleControls" role="button"
                                            data-bs-slide="prev">
                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span class="sr-only">Previous</span>
                                        </a>
                                        <a class="carousel-control-next" href="#carouselExampleControls" role="button"
                                            data-bs-slide="next">
                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span class="sr-only">Next</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div class="row">
                                    <div class="col-md-12 mb-3" v-for="loader in links_loader" :key="loader">
                                        <div class="card border-0 shadow-sm rounded-lg">
                                            <div class="card-body p-2">
                                                <ContentLoader />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-if="links.length > 0" class="row">
                        <div class="col-md-12 mb-2" v-for="link in links" :key="link.id">
                            <div class="card h-100 shadow-sm border-0">
                                <a :href="link.link" target="_blank">
                                <div class="card-img">
                                    <img :src="link.gambar" class="w-100"
                                        style="height: auto;object-fit: cover;border-top-left-radius: .3rem;border-top-right-radius: .3rem;">
                                </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <div class="row">
                            <div class="col-md-6 mb-3" v-for="loader in links_loader" :key="loader">
                                <div class="card border-0 shadow-sm rounded-lg">
                                    <div class="card-body p-2">
                                        <ContentLoader />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                            <!-- end banner link section -->
                        </div>
                        <!-- <div>
                    Banner Multi Items
                </div> -->
                    </div>
                </div>
            </section>
        </div>
        <!-- end main content -->

        <!-- footer -->
        <Footer />
        <!-- end footer -->
    </div>
</template>

<script>
//import content loader
import {
    ContentLoader,
    FacebookLoader,
    ListLoader
} from 'vue-content-loader';

//import axios
import axios from 'axios';

//import moment
import moment from 'moment';
var hijriah = require('moment-hijri');

//import hook onMounted from vue
import { ref, onMounted } from 'vue';

//import component
import Header from "@/components/Header";
import Slider from "@/components/Slider";
import Footer from "@/components/Footer";

export default {
    name: 'HomeComponent',
    // mounted() {  
    //     const nama_web = ref([]);
    //     //get nama web
    //     axios.get('/api/webconfig')
    //         .then(response => {
    //             nama_web.value = response.data.data[0].nama_web;

    //             document.title = nama_web.value;
    //         })  
    // },

    components: {
        //loader component
        ContentLoader,
        FacebookLoader,
        ListLoader,
        //component app
        Header,
        Slider,
        Footer
    },

    methods: {
        dateTime(value) {
            return moment(value).locale('id').format('LL');
        },
        dateNow() {
            return moment().locale('id').format('dddd, LL');
        },
        dateHijr() {
            return hijriah().locale('id').format('dddd, iD iMMMM iYYYY');
        }
    },

    setup() {

        //define state
        const web = ref([]);
        // const url_web  = ref([]);

        const kepalas = ref([]);
        const kepalas_loader = ref(1);

        const sambutans = ref([]);
        const sambutans_loader = ref(1);

        const beritas = ref([]);
        const beritas_loader = ref(3);

        const beritakota = ref([]);

        const videos = ref([]);
        const videos_loader = ref(2);

        const agendas = ref([]);
        const agendas_loader = ref(2);

        const tags = ref([]);

        const photos = ref([]);
        const photos_loader = ref(6);

        const pengumumans = ref([]);
        const pengumumans_loader = ref(2);

        const links = ref([]);
        const links_loader = ref(2);

        var ip;

        const fetchDataWeb = () => {
            //get nama web
            axios.get('/api/webconfig')
                .then(response => {
                    web.value = response.data.data[0];
                    // url_web.value   = response.data.data[0].url_admin;

                    // console.log(url_web);
                })

        }

        //hook onMounted
        onMounted(() => {
            // ig (elfsight)
            // const script = document.createElement("script");
            // script.src = "https://static.elfsight.com/platform/platform.js";
            // script.async = true;
            // document.body.appendChild(script);

            //get nama dan foto kepala
            axios.get('/api/kepala')
                .then(response => {
                    kepalas.value = response.data.data;
                })

            //get sambutan
            axios.get('/api/sambutan')
                .then(response => {
                    sambutans.value = response.data.data;
                })

            //get beritas
            axios.get('/api/beranda/berita')
                .then(response => {
                    beritas.value = response.data.data.data;
                })

            //get berita kota
            axios.get('https://api-splp.layanan.go.id/t/kotabogor.go.id/KotaBogor/1.0/berita?key=b3r1t4b0g0r', {
                headers: { apikey: 'eyJ4NXQiOiJOVGRtWmpNNFpEazNOalkwWXpjNU1tWm1PRGd3TVRFM01XWXdOREU1TVdSbFpEZzROemM0WkE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJia2FkQGtvdGFib2dvci5nby5pZCIsImFwcGxpY2F0aW9uIjp7Im93bmVyIjoiYmthZEBrb3RhYm9nb3IuZ28uaWQiLCJ0aWVyUXVvdGFUeXBlIjpudWxsLCJ0aWVyIjoiVW5saW1pdGVkIiwibmFtZSI6IndlYnNpdGVia2FkIiwiaWQiOjQzOSwidXVpZCI6IjM2NWE3OGFmLTkxMTAtNGIwZS05ZWQ2LWY1MTExNDA5MThiYiJ9LCJpc3MiOiJodHRwczpcL1wvc3BscC5sYXlhbmFuLmdvLmlkOjQ0M1wvb2F1dGgyXC90b2tlbiIsInRpZXJJbmZvIjp7IlVubGltaXRlZCI6eyJ0aWVyUXVvdGFUeXBlIjoicmVxdWVzdENvdW50IiwiZ3JhcGhRTE1heENvbXBsZXhpdHkiOjAsImdyYXBoUUxNYXhEZXB0aCI6MCwic3RvcE9uUXVvdGFSZWFjaCI6dHJ1ZSwic3Bpa2VBcnJlc3RMaW1pdCI6MCwic3Bpa2VBcnJlc3RVbml0IjpudWxsfX0sImtleXR5cGUiOiJQUk9EVUNUSU9OIiwic3Vic2NyaWJlZEFQSXMiOlt7InN1YnNjcmliZXJUZW5hbnREb21haW4iOiJrb3RhYm9nb3IuZ28uaWQiLCJuYW1lIjoiS290YUJvZ29yIiwiY29udGV4dCI6IlwvdFwva290YWJvZ29yLmdvLmlkXC9Lb3RhQm9nb3JcLzEuMCIsInB1Ymxpc2hlciI6ImFkbWluQGtvdGFib2dvci5nby5pZCIsInZlcnNpb24iOiIxLjAiLCJzdWJzY3JpcHRpb25UaWVyIjoiVW5saW1pdGVkIn1dLCJ0b2tlbl90eXBlIjoiYXBpS2V5IiwiaWF0IjoxNjYxNTA0ODcyLCJqdGkiOiI1ZWVjNzcyMi1iYzMwLTRiMTMtYWE4NC1mYThkMjEwODYwNWEifQ==.Orr7CaVKkU_j3CSXv2xjmL0Wif5p01XW9FmohIe4dwlztjVi9R8CBzv122-24yCeSZqGSzPWMUBASSq604SVKaIoTImbx1QouZ4YV92bdvQiw_B2PSVbSnmrmYRkrWYISRhcOBCbt7v6hp89LgT_weinS5fPm38mJA-kzPV2XKS0W1GctcYDFf_N0OoLrfmw1iplzVDPM-zV20hATsUEAfsOlhOAnVwdawH6MQpOMTvnZbGoNG9U7VONK4tKoWfg4N73PgnskQy_zT-YQn-vINg_Cxz07-569CsWQs3lGSNjs-cWh-86F_AtwZjfI5R-wIsXoz1cwijOxkowgfgAtA==' },
            })
                .then(response => {
                    beritakota.value = response.data;
                })

            //get videos
            axios.get('/api/homepage/video')
                .then(response => {
                    videos.value = response.data.data;
                })

            //get agendas
            axios.get('/api/homepage/agenda')
                .then(response => {
                    agendas.value = response.data.data;
                })

            //get tags
            axios.get('/api/tag')
                .then(response => {
                    tags.value = response.data.data.data;
                })
                .catch(() => {
                    tags.value = [];
                });

            //get photos
            axios.get('/api/homepage/photo')
                .then(response => {
                    photos.value = response.data.data;
                })

            //get banner pengumuman
            axios.get('/api/banneriklan')
                .then(response => {
                    pengumumans.value = response.data.data;
                })

            //get banner link
            axios.get('/api/bannerlink')
                .then(response => {
                    links.value = response.data.data;
                })

            //get ip address
            axios.get("https://jsonip.com")
                .then(response => {
                    ip = response.data.ip;
                    // console.log(response.data.ip)

                    //add visitor
                    axios.get('/api/addvisitor/' + ip)
                })

            fetchDataWeb()
        });

        //return state
        return {
            web,
            // url_web,
            kepalas,
            kepalas_loader,
            sambutans,
            sambutans_loader,
            beritas,
            beritas_loader,
            beritakota,
            videos,
            videos_loader,
            agendas,
            agendas_loader,
            tags,
            photos,
            photos_loader,
            pengumumans,
            pengumumans_loader,
            links,
            links_loader
        }
    }
}
</script>